import { render, staticRenderFns } from "./ReviewPageV2.vue?vue&type=template&id=7dc8f6ae&scoped=true&"
import script from "./ReviewPageV2.vue?vue&type=script&lang=js&"
export * from "./ReviewPageV2.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPageV2.vue?vue&type=style&index=0&id=7dc8f6ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc8f6ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
